import { render, staticRenderFns } from "./CategoriesCard.vue?vue&type=template&id=16c37634&"
import script from "./CategoriesCard.vue?vue&type=script&lang=js&"
export * from "./CategoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports